import moment from 'moment/moment';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { RootStateOrAny, useSelector } from 'react-redux';

function StoreNotOpenRemind({ serveType, webStoreVo }) {
  const intl = useIntl();
  if (!serveType) {
    serveType = useSelector<RootStateOrAny, any>(
      (state) => state.modeReducer.serveType
    );
  }
  switch (serveType) {
    case 'DINE_IN':
      return (
        <div
          className="d-flex"
          style={{ color: '#FF8A80', fontSize: '12px', paddingTop: '20px' }}
        >
          <div style={{ color: '#FF8A80', fontSize: '5px', padding: '5px' }}>
            ●
          </div>
          <FormattedMessage
            id="welcome.store.not.open"
            values={{
              serveType: intl.formatMessage({
                id: 'welcome.availableServeTypes.DINE_IN',
              }),
            }}
          />

          <FormattedMessage
            id="welcome.business.time"
            values={{
              startTime: webStoreVo?.startTime,
              endTime: webStoreVo?.endTime,
            }}
          />
        </div>
      );
    case 'TAKE_OUT':
      return (
        <div
          className="d-flex"
          style={{ color: '#FF8A80', fontSize: '12px', paddingTop: '20px' }}
        >
          <div style={{ color: '#FF8A80', fontSize: '5px', padding: '5px' }}>
            ●
          </div>
          <FormattedMessage
            id="welcome.store.not.open"
            values={{
              serveType: intl.formatMessage({
                id: 'welcome.availableTakeOutServeTypes.TAKE_OUT',
              }),
            }}
          />
          <FormattedMessage
            id="welcome.business.time"
            values={{
              startTime: webStoreVo?.startTime,
              endTime: webStoreVo?.endTime,
            }}
          />
        </div>
      );
    default:
      return null;
  }
}

StoreNotOpenRemind.propTypes = {
  serveType: PropTypes.any,
  webStoreVo: PropTypes.any,
};

export default StoreNotOpenRemind;
